import { toast } from 'react-toastify';

import { helper } from '@dinnisoft/esteio-gestao-common';

export const handleApiError = (err: any) => {
  const errorMessage = helper.apiErrorMessage(err);

  toast.error(errorMessage);
};
